import { createGlobalStyle } from 'styled-components';
import { buttonStyles } from '../../Controls/Button';
export const CalendarStyleOverrides = createGlobalStyle `
  .fc-button-group {
    gap: 0.5em;
  }

  .fc-direction-ltr .fc-toolbar > *:not(:first-child) {
    margin-left: 1em;
  }

  .fc .fc-button {
    ${buttonStyles};
    padding: 0 12px;
    width: unset;
    font-size: 14px;
  }

  .fc .fc-button-primary:not(:disabled).fc-button-active:focus,
  .fc .fc-button-primary:not(:disabled):active:focus,
  .fc .fc-button-primary:focus {
    ${({ theme }) => theme.shadows.focus};
  }

  .fc .fc-prev-button:not(:disabled),
  .fc .fc-next-button:not(:disabled) {
    background: transparent;
    border: 2px solid ${({ theme }) => theme.colors.warning100};
    border-radius: 4px;
    padding: 0 0.5em;
    color: ${({ theme }) => theme.colors.black_1} !important;

    &:hover,
    &:active {
      color: ${({ theme }) => theme.colors.grey00_1} !important;
      border-color: ${({ theme }) => theme.colors.mainDark};
    }
  }

  .fc-direction-ltr .fc-button-group>.fc-button:not(:last-child),
  .fc-direction-ltr .fc-button-group>.fc-button:not(:first-child) {
    border-radius: 4px;
  }
`;
export const CalendarStyleVariables = createGlobalStyle `
  body {
    --fc-button-bg-color: ${({ theme }) => theme.colors.main};
    --fc-button-border-color: ${({ theme }) => theme.colors.main};
    --fc-button-hover-bg-color: ${({ theme }) => theme.colors.mainDark};
    --fc-button-hover-border-color: ${({ theme }) => theme.colors.mainDark};
    --fc-button-active-bg-color: ${({ theme }) => theme.colors.mainDark};
    --fc-button-active-border-color: ${({ theme }) => theme.colors.mainDark};
    --fc-event-bg-color: ${({ theme }) => theme.colors.link100};
    --fc-event-border-color: ${({ theme }) => theme.colors.link100};
    --fc-today-bg-color: ${({ theme }) => theme.colors.mainLight};
    --fc-highlight-color: ${({ theme }) => theme.colors.mainLight};
    --fc-bg-event-color: ${({ theme }) => theme.colors.positive100};
  }
`;
